<template>
    <div class="modal fade" id="modalUpdateFinanceEmailList" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">All Email List</h4>
            </div>
            <button type="button" class="close" @click="cancelUpdateEmail">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="container mb-2">
              <div class="row align-items-center">
                  <div class='col-lg-8 pl-0 pr-1 pt-1'>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search By Email"
                      name="depositDate"
                      @input="searchEmailData"
                      v-model="searchEmail"
                    />
                  </div>
                  <div class='col-lg-4 pl-0 pr-1 pt-1'>
                    <div class="mt-1" style="text-align:center;">
                      <button type="button" class="btn btn-link" @click="addMoreFinanceEmail">
                        + Tambah Email 
                      </button>
                    </div>
                  </div>
                </div>
            </div>
            <div v-for="(email, i) in financeEmailList.filter(item =>item.includes(searchEmail) )" :key="i" class="one-line">
              <div class="container mb-2">
                <div class="row align-items-center">
                  <div
                    class='col-lg-2 pl-0 pr-1 pt-2'
                  >
                    <label class="ol-label" style="font-weight : 500; font-size: 16px; color:#2E3646"> Email {{ i + 1 }} </label>
                    <label class="ol-titik2" style="font-weight : 500; font-size: 16px; color:#2E3646">:</label>
                  </div>
                  <div
                    class='col-lg-9 pl-0 pr-1'
                  >
                    <input
                      type="text"
                      name="financeEmail"
                      :disabled="searchEmail.length > 0"
                      v-model="financeEmailList[i]"
                      :class="{ 'form-control': true,'border-red' : errorFinanceEmail.includes(financeEmailList[i])}"
                    />
                    <p v-if="errorFinanceEmail.includes(financeEmailList[i])" class="text-danger m-0 p-0" style="font-size: 12px">Email is not valid</p>
                  </div>
                  <div class="col-lg-1 px-0">
                    <button
                      @click="deleteFinanceEmail(i)"
                      class="btn btn-warning btn-sm py-1 w-150 ml-1"
                      style="color : #FFFFFF;"
                      :disabled="financeEmailList.length == 1"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc. --> <path fill="#ffffff" d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg> 
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              @click="cancelUpdateEmail"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitChange"
              v-if="!loadingButtonSave"
              :disabled="allEmailFilled == false"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else-if="loadingButtonSave"
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Save
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import validateMixin from '../../../mixins/validate'
import swal from 'sweetalert'
export default {
  name: 'ModalUpdateFinanceEmailList',
  props: ['emailList', 'saveChanges'],
  mixins: [validateMixin],
  data () {
    return {
        displayedEmailList : [],
        financeEmailList : [],
        financeEmailData : "",
        searchEmail : '',
        loadingButtonSave : false,
        allEmailFilled : false,
        errorFinanceEmail:[]
    }
  },
  methods:{
    searchEmailData() {
      if(this.searchEmail) {
        this.displayedEmailList = this.financeEmailList.filter((item) => item.includes(this.searchEmail))
      } else {
        this.displayedEmailList = this.financeEmailList
      }
    },
    cancelUpdateEmail() {
      this.closeModal('UpdateFinanceEmailList')
      this.errorFinanceEmail = []
      setTimeout(() => {
        this.searchEmail = ''
        this.displayedEmailList = [...this.financeEmailData]
        this.financeEmailList = [...this.financeEmailData]
      }, 200)
     
    },
    addMoreFinanceEmail() {
      this.financeEmailList.push('');
    },
    deleteFinanceEmail(index) {
        this.financeEmailList.splice(index,1)
    },
    submitChange () {
        let newEmailData = []
        this.financeEmailList.forEach(item => {
          if(item) {
           newEmailData.push(item)
          }
        })
        // Check if all email is valid
        const invalidEmails = newEmailData.filter((email) => !this.validateEmail(email));
        if (invalidEmails.length > 0) {
          this.errorFinanceEmail = invalidEmails
          swal("Sorry", "Finance email must be filled or valid format", "error", {
              button: "Ok",
          })
        } else {
          this.errorFinanceEmail = []
          this.saveChanges(newEmailData)
        }
    },
    closeModal(name){
      $("#modal"+name).modal('hide')
    },
  },
  watch : {
    financeEmailList: {
      handler: function (val) {
        let isEmail = /\S+@\S+\.\S+/;
        if(val) {
          if (val.length == 1) {
            if (isEmail.test(val[0])) {
              this.allEmailFilled = true;
            } else {
              this.allEmailFilled = false;
            }
          } else if (val.length > 1) {
            for (let i in val) {
              if (
                val[i] == "" ||
                val == null ||
                !isEmail.test(val[i])
              ) {
                this.allEmailFilled = false;
              } else {
                this.allEmailFilled = true;
              }
            }
          }
        }
        
      },
    },
    emailList : {
      handler : function (val) {
        this.financeEmailList = [...val]
        this.financeEmailData = [...val]
        this.displayedEmailList = [...val]
      }
    }
  },
  created(){
    this.financeEmailList =  [...this.emailList]
    this.displayedEmailList = [...this.emailList]
    this.financeEmailData = [this.emailList]
    // this.getData()
    // this.admin = localStorage.getItem('admin_name')
    // this.cekLogin()
    // this.cekPermission()
  }
}
$(document).ready(function(){
  var self = this
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .border-red{
    border-color:red;
  }
  .modal-title{
    font-size: 24px;
    font-weight: 700;
    line-height: 29px;
    letter-spacing: 0em;
    text-align: left;
  }
  .check-box-text {
    color: #2E3646;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */
    letter-spacing: -0.016px;
  }

  .most-overdue-title {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-text {
    color: #2E3646;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-orange {
    color: #FF5252;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Invoicing/CustomComponent/ModalUpdateFinanceEmailList.vue